/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import LinkCell from '@/backgrid/LinkCell';
import PageableCollection from '@/backbone/PageableCollection';
import { userHasRole } from '@/util/RoleUtils';
import OrderPackageStatuses from '@/enums/OrderPackageStatuses';

const OrderPackageDashboardGridView = GridView.extend({
  initialize() {
    this.options.columns = [
      {
        name: 'id',
        label: 'Order Package ID',
        cell: StringCell,
        headerCell: 'custom',
        editable: false,
        sortable: true
      },
      {
        name: 'assignedCRS',
        label: 'Assigned CRS',
        cell: StringCell,
        headerCell: 'custom',
        editable: false,
        sortable: true
      },
      {
        name: 'assignedEPC',
        label: 'Assigned EPC',
        cell: StringCell,
        headerCell: 'custom',
        editable: false,
        sortable: true
      },
      {
        name: 'orderPackageType',
        label: 'Order Type',
        cell: StringCell,
        headerCell: 'custom',
        editable: false,
        sortable: true
      },
      {
        name: 'orderPackageStatus',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        editable: false,
        sortable: true
      },
      {
        name: 'awPackageID',
        label: 'AW Package ID',
        cell: LinkCell.extend({
          name() {
            return this.model.get('awPackageID');
          },
          href(model) {
            return `#aw-package/${model.get('awPackageID')}`;
          },
          newTab: true
        }),
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'popStartDate',
        label: 'POP Start Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'createdOn',
        label: 'Created On',
        cell: DateCell,
        headerCell: 'custom',
        editable: false,
        sortable: true
      },
      {
        name: '',
        label: '',
        editable: false,
        sortable: false,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          href(model) {
            return `#order-package/${model.get('id')}`;
          },
          newTab: true,
          buttonClass(model) {
            return userHasRole('EPC') && model.get('statusID') === OrderPackageStatuses.EPC_PENDING_ASSIGNMENT
              ? 'd-none'
              : 'btn-sm btn-outline-primary';
          }
        })
      }
    ];
    this.collection = new PageableCollection([], { pageSize: 50 });
    this.options.emptyText = 'No Order Packages Found';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});
export default OrderPackageDashboardGridView;
